import styled from "styled-components";
import SVG from "../../sharedUI/SVG";
import { breakPoints, colors, measurments, shadows } from "../../utils/config";
import Button from "../../sharedUI/Button";
import Tag from "../../sharedUI/Tag";

const StyledPlanCard = styled.div`
  margin-bottom: 1rem;
  background: white;
  border-radius: ${measurments.borderRadius}px;
  box-shadow: ${shadows[2]};
  overflow: hidden;
  display: grid;
  grid-template-columns: 140px 1fr;
  .entry-image {
    border-radius: ${measurments.borderRadius}px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${colors.neutral[20]};
    svg {
      width: 50px;
      height: 50px;
      object-fit: cover;
    }
  }
  .entry-text-container {
    padding: 1.5rem 2.2rem 1rem 1.5rem;
    .published-status {
      align-self: flex-start;
      display: flex;
      background: ${colors.danger.bgColor};
      border: 1px solid ${colors.danger.border};
      padding: 0.2rem 0.9rem;
      border-radius: 50px;
      p {
        margin-right: 0.3rem;
        color: ${colors.danger.main};
      }
      svg {
        width: 12px;
        height: 12px;
      }
      &.published {
        background: ${colors.success.bgColor};
        border: 1px solid ${colors.success.border};
        p {
          color: ${colors.success.main};
        }
      }
    }
  }
  ${breakPoints.tablet} {
    display: block;
    .entry-text-container {
      padding: 1rem;
    }
  }
`;

const PlanCard = ({ entry, deleteInit, editInit, sortPlan, index, length }) => {
  return (
    <StyledPlanCard>
      <div className="entry-image">
        <SVG name="pdf" />
      </div>
      <div className="entry-text-container">
        <div className="flex ac jcsb">
          <div>
            <p className="h3 m0">{entry.title}</p>
            <div className="mtop05 flex gap05 wrap">
              {entry.tags.map((tag) => (
                <Tag
                  key={`${entry._id}_tag_${tag}`}
                  tagName={tag}
                  bgColor={colors.neutral[40]}
                  size="small"
                />
              ))}
            </div>
          </div>
          <div
            className={`published-status ${entry.published ? "published" : ""}`}
          >
            <p className="m0 b3">
              {entry.published ? "Publicerad" : "Ej publicerad"}
            </p>
            <SVG
              name="upload-cloud"
              stroke={
                entry.published ? colors.success.main : colors.danger.main
              }
            />
          </div>
        </div>
        <div className="flex mtop2 ac jce gap05">
          {index !== 0 && (
            <div
              title="Flytta kurs uppåt"
              className="pointer"
              onClick={() => sortPlan({ plan: entry, isUp: true })}
            >
              <SVG stroke={colors.neutral[70]} name="arrow-up-square" />
            </div>
          )}
          {index !== length - 1 && (
            <div
              title="Flytta kurs nedåt"
              className="pointer"
              onClick={() => sortPlan({ plan: entry })}
            >
              <SVG stroke={colors.neutral[70]} name="arrow-down-square" />
            </div>
          )}
          <Button onClick={() => editInit(entry)}>Redigera</Button>
          <Button onClick={() => deleteInit(entry)} btnType="danger">
            Radera
          </Button>
        </div>
      </div>
    </StyledPlanCard>
  );
};

export default PlanCard;
